export default __webpack_public_path__ + "static/media/ThinkGate.b1604d4a50e3e6fd260a0ab15d638af7.webp";